import { Component } from '@angular/core';
import { NbComponentStatus, NbDialogRef } from "@nebular/theme";

/**
 * Shared "give a reason" prompt — the Nebular-native replacement for window.prompt().
 * Resolves (via onClose) to the trimmed reason string on confirm, or null on cancel.
 * When `required` (the default) an empty reason disables confirm, mirroring the
 * backend's non-empty enforcement. Callers tune title/labels/status via context.
 */
@Component({
  selector: 'bst-reason-dialog',
  templateUrl: './reason-dialog.component.html',
  styleUrls: ['./reason-dialog.component.scss'],
  standalone: false
})
export class ReasonDialogComponent {
  public title: string = 'reason';
  public subtitle: string = null;
  public placeholder: string = 'reason';
  public confirmLabel: string = 'confirm';
  public cancelLabel: string = 'cancel';
  public status: NbComponentStatus = 'primary';
  public required: boolean = true;
  public reason: string = '';

  constructor(protected ref: NbDialogRef<ReasonDialogComponent>) {}

  cancel() {
    this.ref.close(null);
  }

  submit() {
    const value = (this.reason || '').trim();
    if (this.required && !value) { return; }
    this.ref.close(value);
  }
}
